import api from './api';

export default function submitErrorReport(data) {
  return api.post('/api/ui/support/error', { data });
}
